import React from "react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import { Box, Text } from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import RichTextField, { RichTextFieldType } from "components/ReactHookForm/RichTextField"
import ModalContentWrapper from "./ModalContentWrapper"

type Props = {
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const EventDetailsModal = ({
  onHide,
  event: {
    portalDateTimeLocation,
  },
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  const values = {
    portalDateTimeLocation,
  }

  const handleSubmit = async (data) => {
    await updateEvent(data)
    onHide()
  }

  const handleCancel = () => {
    onResetEventWorkingCopy()
    onHide()
  }

  return (
    <ModalForm
      size="xl"
      noPadding
      initialValues={values}
      title="Event Details"
      onSubmit={handleSubmit}
      onClose={handleCancel}
      onChange={onChangeEventWorkingCopy}
      disableSubmitWhenNotDirty
    >
      {({ control }) => (
        <ModalContentWrapper>
          <Box px={6} pt={4}>
            <Box mb={4}>
              <Text>
                Display essential event information for guests. By default, this
                includes the <b>date, time, and location,</b> but you can customize it
                or add other important event details.
              </Text>
            </Box>
            <RichTextField
              control={control}
              name="portalDateTimeLocation"
              type={RichTextFieldType.MINIMAL}
              className="date-time-and-location-editor"
            />
            <Text color="gray.500" fontSize="sm">
              Editing this section will not change the actual event attributes.
            </Text>
          </Box>
        </ModalContentWrapper>
      )}
    </ModalForm>
  )
}

export default EventDetailsModal
